import { useState, useCallback } from 'react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', options = {}) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      message,
      type,
      duration: options.duration || 4000,
      title: options.title || '',
    };

    setToasts((prev) => [...prev, newToast]);

    // Auto remove after duration
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, newToast.duration + 300);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const clearToasts = useCallback(() => {
    setToasts([]);
  }, []);

  // Helper methods
  const success = useCallback((message, options = {}) => {
    return addToast(message, 'success', options);
  }, [addToast]);

  const error = useCallback((message, options = {}) => {
    return addToast(message, 'error', options);
  }, [addToast]);

  const warning = useCallback((message, options = {}) => {
    return addToast(message, 'warning', options);
  }, [addToast]);

  const info = useCallback((message, options = {}) => {
    return addToast(message, 'info', options);
  }, [addToast]);

  return {
    toasts,
    addToast,
    removeToast,
    clearToasts,
    success,
    error,
    warning,
    info,
  };
};